import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-520d996b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout",
  src: "/assets/icon/mensagens.svg"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Mensagens ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Confira aqui suas mensagens ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "avatar-ico",
  src: "/assets/icon/js.svg"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "chat-received-msg" }
const _hoisted_10 = { class: "font-suls-l font-12" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Limpar notificações ")
const _hoisted_12 = { class: "chat-notificacao-msg" }
const _hoisted_13 = { class: "titulo" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "font-suls-l font-12" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" LIMPAR")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Digite sua mensagem")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Enviar ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"30px"},
  src: "/assets/icon/enviar.svg"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "avatar-ico",
  src: "/assets/icon/js.svg"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "chat-received-msg" }
const _hoisted_26 = { class: "chat-send-msg" }
const _hoisted_27 = { class: "chat-received-msg" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Digite o sua solicitação")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, { ref: "myContent" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat font-25 layout_blue"
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat-mediun font-20 layout_blue"
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chats, (chat) => {
            return (_openBlock(), _createBlock(_component_ion_row, {
              class: "ion-justify-content-end ion-margin-start ion-margin-end",
              key: chat.id
            }, {
              default: _withCtx(() => [
                (chat.tipo == 2)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 0,
                      class: "ion-text-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _hoisted_8
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (chat.tipo == 2)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 1,
                      size: "10"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(chat.mensagem), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (chat.show && chat.tipo == 2)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(chat.opcoes, (chatoptions, index) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        onClick: ($event: any) => (_ctx.chatOpcao(chatoptions, chat)),
                        key: 'op_'+chat.id,
                        size: "auto"
                      }, {
                        default: _withCtx(() => [
                          (index === 0)
                            ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_col, { size: "8" }),
                                      _createVNode(_component_ion_col, { size: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_badge, {
                                            color: "jauservelayoutvermelho",
                                            onClick: ($event: any) => (_ctx.clearAllNotifications(chat.opcoes))
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_10, [
                                                _createVNode(_component_ion_icon, { icon: _ctx.iconClose }, null, 8, ["icon"]),
                                                _hoisted_11
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, [
                              _createTextVNode(_toDisplayString(chatoptions.titulo), 1),
                              _hoisted_14
                            ]),
                            _createTextVNode(" " + _toDisplayString(chatoptions.descricao) + " ", 1),
                            _hoisted_15,
                            _createVNode(_component_ion_badge, {
                              color: "jauservelayoutvermelho",
                              onClick: ($event: any) => (_ctx.clearNotifications(chatoptions.idEntidade))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_ion_icon, { icon: _ctx.iconClose }, null, 8, ["icon"]),
                                  _hoisted_17
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  : _createCommentVNode("", true),
                (chat.tipo == 2 && chat.form_show && !chat.is_disable)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 3,
                      class: "ion-text-center",
                      size: "10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { class: "roundedInputArea" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_textarea, {
                              modelValue: _ctx.sendMensagem,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sendMensagem) = $event)),
                              placeholder: "Digite aqui sua mensagem",
                              "auto-grow": true,
                              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendMensagem=$event.target.value)),
                              name: "sendMensagem",
                              enterkeyhint: "send",
                              type: "text",
                              fill: "outline",
                              rows: "5",
                              spellcheck: "false",
                              autocapitalize: "off",
                              class: "custom",
                              required: "",
                              disabled: chat.is_disable
                            }, null, 8, ["modelValue", "disabled"]),
                            _hoisted_19
                          ]),
                          _: 2
                        }, 1024),
                        _hoisted_20,
                        _createVNode(_component_ion_button, {
                          onClick: ($event: any) => (_ctx.chatSendForm(chat)),
                          size: "large",
                          color: "jauservelayoutalter",
                          shape: "jau",
                          disabled: chat.is_disable
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21,
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (chat.tipo == 0)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 4,
                      class: "ion-text-center",
                      size: "auto"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23,
                        _hoisted_24
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (chat.tipo == 0)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 5,
                      size: "10"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(chat.mensagem), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (chat.show && chat.tipo == 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 6 }, _renderList(chat.opcoes, (chatoptions) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        class: "chat-opcoes-msg",
                        onClick: ($event: any) => (_ctx.chatOpcao(chatoptions, chat)),
                        key: 'op_'+chat.id,
                        size: "auto"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(chatoptions.mensagem), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  : _createCommentVNode("", true),
                (chat.tipo == 1)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 7,
                      size: "auto"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(chat.mensagem), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_ion_row, { class: "ion-justify-content-end ion-margin-start ion-margin-end" }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    ref: "loading",
                    size: "10"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_ion_spinner, { name: "dots" })
                      ])
                    ]),
                    _: 1
                  }, 512))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          (_ctx.chatGpt)
            ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { class: "roundedInput" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "floating" }, {
                            default: _withCtx(() => [
                              _hoisted_28
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.sendMensagem,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sendMensagem) = $event)),
                            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendMensagem=$event.target.value)),
                            name: "sendMensagem",
                            enterkeyhint: "send",
                            onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.chatSend()), ["enter"])),
                            type: "text",
                            spellcheck: "false",
                            autocapitalize: "off",
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center ion-no-padding",
                    size: "1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.chatSend())),
                        color: "jauservelayoutalter",
                        shape: "jau",
                        size: "large",
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.iconEnviar
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}